import React, { Component } from 'react';
import styled from 'styled-components';
import { CardElement, injectStripe } from 'react-stripe-elements';
import Button from '../../../components/atomic/Buttons/Button';

const Container = styled.div`
  width: 75%;
`;
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
`;
const ButtonStyled = styled(Button)`
  margin-left: 8px;
`;

class PaymentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      complete: false,
      errorMessage: null,
      subscribing: false
    };
  }

  onCardElementChange = changeObject => {
    const { complete, error } = changeObject;

    const state = {
      errorMessage: error ? error.message : null,
      complete
    };

    this.setState({ ...state });
  }

  handleSubmit = async (ev) => {
    ev.preventDefault();

    const { clientSecret, elements, onPaymentSubmit, stripe } = this.props;

    const cardElement = elements.getElement('card');

    const results = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
      },
    });

    if (onPaymentSubmit) onPaymentSubmit(results);
  }

  render() {
    const { stripe } = this.props;
    const { complete } = this.state;
    return (
      <Container>
        <form>
          <CardElement onChange={this.onCardElementChange} />
          <ButtonContainer>
            <ButtonStyled color="primary" variant="contained" disabled={!stripe || !complete} onClick={this.handleSubmit}>Submit Payment</ButtonStyled>
          </ButtonContainer>
        </form>
      </Container>
    );
  }
}

export default injectStripe(PaymentForm);
